import React from "react";
import { useHistory } from "react-router-dom";
import * as Path from "routes/paths";
import { IMG_LOGO_1, MAIN_LOGO_DUMMY_ } from "utils/constant";
import ReactPagination from "components/shared/ReactPagination";
import { itemsPerPage, PAGE_LIMIT_TRADE } from "helpers/viewContent";
import { DATE_FORMAT_TIME_ } from "helpers/common";

export default ({
  userPeningListing,
  setFilter,
  filter,
  userPermissions,
  userRole,
}) => {
  const history = useHistory();
  //pagination
  const handlePageChange = (page) => {
    setFilter({
      ...filter,
      page: page,
    });
    window.scrollTo(0, 0);
  };

  const indexOfLastItem = filter?.page * PAGE_LIMIT_TRADE;
  const indexOfFirstItem = indexOfLastItem - PAGE_LIMIT_TRADE;

  const currentItems =
    userPeningListing?.length > 0 &&
    userPeningListing?.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card graph_card">
          <div className="card-body">
            <h4 className="card-title sidebar_title">Pending Clients</h4>
            <div class="table-responsive">
              <table className="table common_tabel_th">
                <thead>
                  <tr>
                    <th> Name </th>
                    <th> Email </th>
                    <th> Mobile Number </th>
                    <th> Created At </th>
                    <th> Status </th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems?.length > 0 &&
                    currentItems.map((list, i) => {
                      return (
                        <tr
                          title="view"
                          className="cursor-pointer"
                          onClick={() =>
                            userRole?.role === "SUBADMIN" &&
                            userPermissions.hasOwnProperty("userCount") &&
                            userPermissions?.userCount.hasOwnProperty("view") &&
                            userPermissions?.userCount?.view
                              ? history.push(`${Path.userview}/${list._id}`)
                              : userRole?.role === "ADMIN"
                              ? history.push(`${Path.userview}/${list._id}`)
                              : "#"
                          }
                        >
                          <td className="d-flex align-items-center">
                            <div className="symbol_img me-2">
                              <img
                                src={
                                  list?.profileImage
                                    ? list?.profileImage
                                    : MAIN_LOGO_DUMMY_
                                }
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                            <b>
                              {list.first_name
                                ? `${list?.first_name} ${list?.last_name}`
                                : "N/A"}
                            </b>
                          </td>
                          <td>{list.email ? list?.email : "N/A"}</td>
                          <td>
                            {list.mobileNumber
                              ? `${list?.countryCode} ${list?.mobileNumber}`
                              : "N/A"}
                          </td>
                          <td>{DATE_FORMAT_TIME_(list?.createdAt)}</td>
                          <td>
                            <label className="badge badge-danger">
                              {list?.status}
                            </label>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            {userPeningListing?.length > 0 && (
              <div className="pagination-box-review">
                <ReactPagination
                  activePage={filter?.page}
                  itemsCountPerPage={PAGE_LIMIT_TRADE}
                  totalItemsCount={userPeningListing?.length}
                  handlePageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
